"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FLOW_NODE_TYPES = void 0;
exports.FLOW_NODE_TYPES = {
    DECISION: 'Decision',
    RECORD_CREATE: 'Record Create',
    RECORD_LOOKUP: 'Record Lookup',
    RECORD_UPDATE: 'Record Update'
};
//# sourceMappingURL=FLOW_NODE_TYPES.js.map